export default __webpack_public_path__ + "static/media/signup-ground.ca451d05.png";